import React, { useContext, useState } from 'react';
import { Pressable, Text } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  LinkContainer,
  LinkSpace,
} from 'app/src/elements';
import Modal from 'app/src/elements/Modal';

import { FEE_TYPES, HIDE_FEE_TYPE } from './queries';
import SubNav from './SubNav';
import EditFeeType from './edit';

const baseColumns = [
  {
    key: 'name',
    label: 'Name',
    sort: 'asc',
  },
  {
    key: 'chargeAccount',
    label: 'P&L Account',
    value: ({ value }) => value.name,
  },
];

const FeeTypes = () => {
  const [showEditModal, setShowEditModal] = useState();
  const { currentUser } = useContext(AuthContext);

  const { data, refetch } = useQuery(FEE_TYPES);

  const [hideFeeType] = useMutation(
    HIDE_FEE_TYPE, { onCompleted: refetch }
  );

  if (!data) { return <DataState.Loading /> };

  const onHide = feeType => {
    if (window.confirm(`Hide ${feeType.name}?`)) {
      hideFeeType({ variables: { id: feeType.id }});
    }
  };

  const columns = [
    ...baseColumns,
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => (
        <LinkContainer>
          <Pressable onPress={() => setShowEditModal(entry)}>
            <Text>Edit</Text>
          </Pressable>
          <LinkSpace />
          {currentUser?.accounting && (
            <Pressable onPress={() => onHide(entry)} >
              <Text>Hide</Text>
            </Pressable>
          )}
        </LinkContainer>
      )
    },
  ];

  return (
    <MainContainer>
      <SubNav refetch={refetch} />

      <ContentContainer>
        <PageTitle>Fee Types</PageTitle>

        <DataTable.Simple
          data={data.feeTypes}
          columns={columns}
        />
      </ContentContainer>

      {showEditModal &&
        <Modal
          showModal
          setShowModal={setShowEditModal}
          modalType="Edit Fee Type"
        >
          <EditFeeType
            feeType={showEditModal}
            setShowModal={setShowEditModal}
            refetch={refetch}
          />
        </Modal>
      }
    </MainContainer>
  );
};

export default FeeTypes;
